import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum Weight {
  LBS_100_OR_LESS = "100",
  LBS_105 = "105",
  LBS_110 = "110",
  LBS_115 = "115",
  LBS_120 = "120",
  LBS_125 = "125",
  LBS_130 = "130",
  LBS_135 = "135",
  LBS_140 = "140",
  LBS_145 = "145",
  LBS_150 = "150",
  LBS_155 = "155",
  LBS_160 = "160",
  LBS_165 = "165",
  LBS_170 = "170",
  LBS_175 = "175",
  LBS_180 = "180",
  LBS_185 = "185",
  LBS_190 = "190",
  LBS_195 = "195",
  LBS_200_OR_MORE = "200",
}

const WEIGHT_ATTRIBUTE_OPTIONS: ReadonlyArray<AttributeValue> = [
  {
    id: Weight.LBS_100_OR_LESS,
    label: "100 pounds (45kg) or less",
    iconLabel: "▁",
  },
  { id: Weight.LBS_105, label: "105 lbs (48kg)", iconLabel: "▂" },
  { id: Weight.LBS_110, label: "110 lbs (50kg)", iconLabel: "▃" },
  { id: Weight.LBS_115, label: "115 lbs (52kg)", iconLabel: "▄" },
  { id: Weight.LBS_120, label: "120 lbs (54kg)", iconLabel: "▅" },
  { id: Weight.LBS_125, label: "125 lbs (57kg)", iconLabel: "▆" },
  { id: Weight.LBS_130, label: "130 lbs (59kg)", iconLabel: "▇" },
  { id: Weight.LBS_135, label: "135 lbs (61kg)", iconLabel: "█" },
  { id: Weight.LBS_140, label: "140 lbs (64kg)", iconLabel: "█▁" },
  { id: Weight.LBS_145, label: "145 lbs (66kg)", iconLabel: "█▂" },
  { id: Weight.LBS_150, label: "150 lbs (68kg)", iconLabel: "█▃" },
  { id: Weight.LBS_155, label: "155 lbs (70kg)", iconLabel: "█▄" },
  { id: Weight.LBS_160, label: "160 lbs (73kg)", iconLabel: "█▅" },
  { id: Weight.LBS_165, label: "165 lbs (75kg)", iconLabel: "█▆" },
  { id: Weight.LBS_170, label: "170 lbs (77kg)", iconLabel: "█▇" },
  { id: Weight.LBS_175, label: "175 lbs (79kg)", iconLabel: "██" },
  { id: Weight.LBS_180, label: "180 lbs (82kg)", iconLabel: "██▁" },
  { id: Weight.LBS_185, label: "185 lbs (84kg)", iconLabel: "██▂" },
  { id: Weight.LBS_190, label: "190 lbs (86kg)", iconLabel: "██▃" },
  { id: Weight.LBS_195, label: "195 lbs (88kg)", iconLabel: "██▄" },
  {
    id: Weight.LBS_200_OR_MORE,
    label: "200 lbs (91kg) or more",
    iconLabel: "██▅",
  },
];

export const UserWeightAttributeSet: UserAttributeSet = {
  id: UserAttributeType.WEIGHT,
  isMultiSelect: false,
  map: attributeListToMap(WEIGHT_ATTRIBUTE_OPTIONS),
} as const;
